import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { getHomePageUrl } from '@futrli/shared-services';
import { NoDataSplashScreen } from '@futrli/ui-components';

interface Props {
  isConsolidation?: boolean;
}

export const EmptyForecastContent = ({ isConsolidation }: Props) => {
  const intl = useIntl();
  const { organisationId: tempOrganisationId, workspaceId: tempWorkspaceId } = useParams();
  const organisationId = tempOrganisationId || '';
  const workspaceId = tempWorkspaceId || '';

  return (
    <NoDataSplashScreen
      title={
        <FormattedMessage
          id="predict.compare_metrics_forecasts"
          defaultMessage="You’ll be able to compare metrics for your budgets, forecasts and scenarios here"
        />
      }
      description={
        <>
          <FormattedMessage
            id="predict.use_one_value_creation_options"
            defaultMessage="Use one of the {creationOptionsNum} creation options above to get started."
            values={{
              creationOptionsNum: isConsolidation
                ? intl.formatMessage({ id: 'common.two_number', defaultMessage: 'two ' })
                : intl.formatMessage({ id: 'common.three_number', defaultMessage: 'three' })
            }}
          />
          {!isConsolidation && (
            <>
              &nbsp;
              <FormattedMessage
                id="predict.use_link_guided_flows"
                defaultMessage="Or use one of the <link>Guided Flows</link> on the Home page."
                values={{
                  link: (chunks: ReactNode[]) => <Link to={getHomePageUrl(workspaceId, organisationId)}>{chunks}</Link>
                }}
              />
            </>
          )}
        </>
      }
    />
  );
};
